import React from 'react'
import Loader from '../../shared/Loader/Loader';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../Setup/Shared/ModalHeader';

const BlockConfirmation = (props) => {

    const { isOpenPopup, onClose, onCloseSave, isLoading } = props;

    const select = () => {
        return <p className='heading Rejected_clr'>Confirm Appointment Cancellation</p>;
    };

    return (
        <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
            <ModalHeader HeaderName={select} DeletePopup={""} isClosed={onClose} key={111} Name={'DiscardChangesPopup'} />
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                <div className='ar-alert d-flex mb-12'>
                    <i className='icon-alert mt-1'></i>
                    <div>
                        <p className='text ms-1'>Appointments are Booked during the selected time slot. Would you like to cancel them ?</p>
                    </div>
                </div>
            </Modal.Body>

            <div className="modal_footer za_br_light br-top-1 pt-2 ">
                <div className='za-button text-end d-flex justify-content-end gap-2'>
                    <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={onClose}>Cancel</button>
                    <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => onCloseSave()}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default BlockConfirmation
